// removed by extract-text-webpack-plugin
module.exports = {"root":"_AIKR"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/message/Message.css
// module id = 755
// module chunks = 0